import { Container, Text } from "@fluidattacks/design";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import { reachabilityFormatter } from "features/vulnerabilities/formatters/reachability";
import type { ReachabilityStatus } from "gql/graphql";

const ReachabilityTag = ({
  reachabilityStatus,
}: {
  reachabilityStatus: ReachabilityStatus | null | undefined;
}): React.JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (_.isNil(reachabilityStatus)) {
    return (
      <Container>
        <Text
          color={theme.palette.gray[400]}
          fontStyle={"italic"}
          size={"md"}
          wordBreak={"break-word"}
          wordWrap={"normal"}
        >
          {t("searchFindings.tabVuln.notApplicable")}
        </Text>
      </Container>
    );
  }

  return reachabilityFormatter(reachabilityStatus);
};

const formatReachability = (
  reachabilityStatus: ReachabilityStatus | null | undefined,
): React.JSX.Element => {
  return <ReachabilityTag reachabilityStatus={reachabilityStatus} />;
};

export { formatReachability };
